import Step01 from "./01Step";
import Step02 from "./02Step";

export const formSteps = {
  1: Step01,
  2: Step02,
};
